<template>
  <v-container>
    <v-row>
      <v-col
        v-for="marketplace in marketplaces"
        :key="marketplace.id"
        xs="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
        class="marketplace-col"
      >
        <v-card class="marketplace-card">
          <router-link
            :to="{
              name: 'marketplace',
              params: { marketplaceId: marketplace.id.toString() },
            }"
            class="marketplace-link"
          >
            <v-img
              v-if="marketplace.image != null && marketplace.image != ''"
              :src="marketplace.image"
              class="marketplace-image"
            />

            <div v-else class="marketplace-image"></div>
          </router-link>

          <v-card-title>
            <router-link
              :to="{
                name: 'marketplace',
                params: { marketplaceId: marketplace.id.toString() },
              }"
              class="marketplace-link"
            >
              {{ marketplace.name }}
            </router-link>
          </v-card-title>

          <v-card-subtitle>{{ marketplace.description }}</v-card-subtitle>

          <v-card-actions>
            <v-btn
              :to="{
                name: 'marketplace',
                params: { marketplaceId: marketplace.id.toString() },
              }"
              color="primary"
            >
              Se butikker
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "MarketplaceList",

  data() {
    return {
      marketplaces: [],
    };
  },

  async created() {
    this.marketplaces = await backend.get("marketplaces/");
  },
};
</script>

<style stoped>
.marketplace-card {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.marketplace-card .marketplace-image {
  height: 13rem;
}

.marketplace-col {
  display: flex;
}

.marketplace-card a.marketplace-link {
  text-decoration: none;
  color: black;
}

.marketplace-card a.marketplace-link:hover {
  text-decoration: underline;
}
</style>
